/**
 * Thrown by a cache store read when it has no connection at all, as opposed to failing a command. Lets an
 * outage be reported as `cacheMissCacheUnavailable` instead of looking like an ordinary miss.
 */
export class CacheStoreUnavailableError extends Error {
    constructor(message = "Cache store is unavailable: no client is connected.") {
        super(message);
        this.name = "CacheStoreUnavailableError";
    }
}
